var _mask, _g, _mask2, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNoData = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 77,
    viewBox: "0 0 81 77",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 0,
    width: 54,
    height: 77
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9478 23.3586C42.6827 29.9286 34.043 43.1716 33.6049 43.5827L38.0178 71.2265L68.0643 76.8318L81.0002 7.49074L50.739 3.03649L46.9478 23.3586Z",
    fill: "#FB8888"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 62,
    height: 66
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.2512,
    y: 0.821533,
    width: 51.4394,
    height: 56.5268,
    transform: "rotate(10.5673 21.2512 0.821533)",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1244 1.57755L30.8393 3.57646L51.5073 42.5966L57.6008 9.93308L71.8626 10.017L61.4517 65.8233L49.269 63.5505L29.7683 26.4154L23.7294 58.786L9.9321 56.2121L20.1244 1.57755Z",
    fill: "#F5F5F5"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 41,
    height: 71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5647 48.8539C33.5526 41.6131 39.6171 27.0103 39.9724 26.5258L30.5647 0.160111L-0.000135866 0.160114L-0.0001297 70.6975L30.5647 69.5266L30.5647 48.8539Z",
    fill: "#FB8888"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 8,
    width: 53,
    height: 57
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5784,
    y: 8.43726,
    width: 51.4394,
    height: 56.5268,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.60938 9.38683H20.5091L47.9825 43.9549V10.7278L62.0178 8.19482V64.9639H49.6249L23.6447 32.0349V64.9639H9.60938V9.38683Z",
    fill: "#F5F5F5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3846 37.8462C54.3846 45.8618 47.8618 52.3846 39.8462 52.3846C31.8305 52.3846 25.3077 45.8618 25.3077 37.8462C25.3077 29.8305 31.8305 23.3077 39.8462 23.3077C47.8618 23.3077 54.3846 29.8305 54.3846 37.8462ZM71 64.8462C71 63.7428 70.5457 62.6719 69.7993 61.9255L58.6683 50.7945C61.2969 46.9976 62.6923 42.4543 62.6923 37.8462C62.6923 25.2224 52.47 15 39.8462 15C27.2224 15 17 25.2224 17 37.8462C17 50.47 27.2224 60.6923 39.8462 60.6923C44.4543 60.6923 48.9976 59.2969 52.7945 56.6683L63.9255 67.7668C64.6719 68.5457 65.7428 69 66.8462 69C69.1178 69 71 67.1178 71 64.8462Z",
    fill: "#D9D9D9"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoData, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/noData.2db70945.svg";
export { ForwardRef as ReactComponent };